import script from "./Refund-Policy.vue?vue&type=script&setup=true&lang=js"
export * from "./Refund-Policy.vue?vue&type=script&setup=true&lang=js"

import "./Refund-Policy.vue?vue&type=style&index=0&id=1c15418e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c15418e"]])

export default __exports__